const Skills = () => {
    const skillCategories = [
        {
            title: "Cybersecurity",
            skills: [
                { name: "Penetration Testing", level: 90 },
                { name: "Vulnerability Assessment", level: 95 },
                { name: "Security Auditing", level: 85 },
                { name: "Incident Response", level: 80 },
                { name: "Threat Modeling", level: 85 }
            ]
        },
        {
            title: "Development",
            skills: [
                { name: "JavaScript/TypeScript", level: 90 },
                { name: "Python", level: 85 },
                { name: "React, Node.js", level: 80 },
                { name: "Golang", level: 85 },
                { name: "SQL/NoSQL", level: 95 }
            ]
        },
        {
            title: "Tools & Technologies",
            skills: [
                { name: "Burp Suite", level: 90 },
                { name: "Metasploit", level: 85 },
                { name: "Docker", level: 80 },
                { name: "Git", level: 90 },
                { name: "CI/CD", level: 75 }
            ]
        }
    ];

    return (
        <section id="skills" className="py-20 bg-gray-50 dark:bg-gray-800">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">My Skills</h2>
                    <div className="w-24 h-1 bg-blue-600 mx-auto rounded"></div>
                    <p className="mt-6 text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                        I've developed expertise across various domains, with a focus on cybersecurity and development.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {skillCategories.map((category, index) => (
                        <div key={index} className="bg-white dark:bg-gray-900 rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
                            <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">{category.title}</h3>
                            <div className="space-y-5">
                                {category.skills.map((skill, skillIndex) => (
                                    <div key={skillIndex}>
                                        <div className="flex justify-between mb-1">
                                            <span className="text-gray-700 dark:text-gray-300">{skill.name}</span>
                                            <span className="text-gray-500 dark:text-gray-400">{skill.level}%</span>
                                        </div>
                                        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
                                            <div
                                                className="bg-gradient-to-r from-blue-600 to-purple-600 h-2.5 rounded-full"
                                                style={{ width: `${skill.level}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">Certifications</h3>
                    <div className="flex flex-wrap justify-center gap-4">
                        <div className="bg-white dark:bg-gray-900 px-6 py-3 rounded-lg shadow-md">
                            <span className="text-gray-700 dark:text-gray-300">Certified Ethical Hacker (CEH)</span>
                        </div>
                        <div className="bg-white dark:bg-gray-900 px-6 py-3 rounded-lg shadow-md">
                            <span className="text-gray-700 dark:text-gray-300">Certified Information Systems Auditor (CISA)</span>
                        </div>
                        <div className="bg-white dark:bg-gray-900 px-6 py-3 rounded-lg shadow-md">
                            <span className="text-gray-700 dark:text-gray-300">EPCSO - IIM Indore</span>
                        </div>
                        <div className="bg-white dark:bg-gray-900 px-6 py-3 rounded-lg shadow-md">
                            <span className="text-gray-700 dark:text-gray-300">CompTIA Security+</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;